'use client';

import { CurrentTaskCta } from '@app/(darkHeader)/ai/_shared/_components/CurrentTaskCta/CurrentTaskCta';
import { useAiToolkitContext } from '@app/(darkHeader)/ai/_shared/_context/AiToolkitContext';
import { AI_TOOLKIT_CATEGORIES } from '@app/(darkHeader)/ai/_shared/_context/types';
import { type JSX } from 'react';

import { GenerateVideo } from '@videoblocks/design-system/icons';

export const CurrentVideoGenerationCta = (): JSX.Element | null => {
    const { submitStates, imageSearch } = useAiToolkitContext();
    const { status, videoUrl, sourceThumbnailUrl } = submitStates[AI_TOOLKIT_CATEGORIES.VIDEO_GENERATION];
    const thumbnailUrl = sourceThumbnailUrl || undefined;

    return (
        <CurrentTaskCta
            title="Current generation"
            status={status}
            thumbnailUrl={thumbnailUrl}
            videoUrl={videoUrl}
            placeholderIcon={<GenerateVideo width={16} height={16} className="dark:[&_path]:fill-neutral-dark-1000" />}
            onClick={() => imageSearch.setShowSearch(false)}
            dataTestId="current-video-generation-cta"
        />
    );
};
